<script setup lang="ts">
import { ref, onMounted} from 'vue';
import {useRouter} from 'vue-router';
import { useModeStore } from '@/stores/modeStore';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import UserDropdown from '@/components/layout/header/UserDropdown.vue';
import ShoppingCartButton from '@/components/layout/header/ShoppingCartButton.vue';

gsap.registerPlugin(ScrollTrigger);
const router =  useRouter();
const navRef = ref<HTMLElement | null>(null);
const modeStore = useModeStore();
const itemsInCart = ref<number>(0);

function selectMode(mode: 'hifi' | 'studio') {
  modeStore.setMode(mode);
  // redirect logic could be done here if not already handled elsewhere
}

const handleGoToHome = () => {
  router.push({ name: 'product-detail' });
};

onMounted(() => {

  const logo = document.querySelector('.logo');

  gsap.to(logo, {
    duration: 1.5,
    repeat: -1,
    yoyo: true,
    ease: 'Power1.inOut',
    filter:'drop-shadow(0 0 5px rgba(255, 255, 255, 0.9)) drop-shadow(0 0 10px rgba(173, 216, 230, 0.8))',
    onStart: () => {
      // Set the initial filter state
      gsap.set(logo, {
        filter: 'drop-shadow(0 0 5px rgba(255, 255, 255, 0.5))'
      });
    },
  });
  const navEl = navRef.value;

  let lastDirection = 1;

  gsap.set(navEl, { y: 0, autoAlpha: 1 });

  gsap.from(navRef.value, {
    y: -60,
    opacity: 0,
    duration: 1,
    ease: 'power2.out'
  });

  ScrollTrigger.create({
    start: 0,
    end: 'bottom bottom',
    onUpdate: (self) => {
      const dir = self.direction;

      // Scroll down (hide nav)
      if (dir === 1 && lastDirection !== 1) {
        gsap.to(navEl, {
          duration: 0.4,
          y: -100,
          autoAlpha: 0,
          ease: 'power2.out',
        });
        lastDirection = 1;
      }

      // Scroll up (show nav)
      if (dir === -1 && lastDirection !== -1) {
        gsap.to(navEl, {
          duration: 0.4,
          y: 0,
          autoAlpha: 1,
          ease: 'power2.out',
        });
        lastDirection = -1;
      }
    },
  });

});

//onUnmounted(() => { });
</script>

<template>
  <nav ref="navRef"
       class="navbar">
    <div class="flex-shrink-0">
      <img src="../../../assets/VV_Logo.png"
           alt="Valve Vista Logo"
           class="logo">
    </div>
    <div>
      <ul class="nav-links gap-4 md:gap-16">
        <li><a class="text-xs md:text-base lg:text-lg"
               @click="handleGoToHome">Home</a></li>
        <li><a class="text-xs md:text-base lg:text-lg"
               @click="handleGoToHome">Products</a></li>
        <li><a class="text-xs md:text-base lg:text-lg"
               @click="handleGoToHome">Testimonials</a></li>
        <li><a class="text-xs md:text-base lg:text-lg"
               @click="handleGoToHome">News</a></li>
      </ul>
    </div>
    <!--NOTE change from buttons to two value toggle instead to save space on mobile. -->
    <!--
    <div v-if="!modeStore.mode"
         class="navbar__right flex-shrink-0 flex-row items-center space-x-2">
      <button class="text-xs px-4 md:px-3 md:py-1"
              @click="selectMode('hifi')">HiFi</button>
      <button class="text-xs px-4 md:px-3 md:py-1"
              @click="selectMode('studio')">Studio</button>
    </div>
    -->
    <!-- New shopping cart div -->
    <div class="flex items-center relative pe-2">
      <UserDropdown />
      <ShoppingCartButton />
      <!--
      <button class="flex items-center justify-center rounded-lg p-2 border text-white hover:border-orange-500 hover:text-orange-500 transition-colors">
        <font-awesome-icon :icon="['fal', 'shopping-cart']"
                           class="text-2xl" />
      </button>
      -->

      <!-- Cart counter div with conditional rendering -->
      <!--
      <div v-if="itemsInCart > 0"
           class="absolute -top-1 right-1 flex h-5 w-5 items-center justify-center rounded-full bg-red-500 text-xs text-white">
        {{ itemsInCart }}
      </div>
      -->
    </div>
  </nav>
</template>


<style scoped>
.navbar {
  position: fixed;
  top: 0;
  width: 100%;
  height: 64px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: rgba(10, 10, 10, 0.1);
  backdrop-filter: blur(10px);
  z-index: 1000;
  pointer-events: all;
  transition: background-color 0.3s ease,opacity 0.4s ease, transform 0.4s ease;
}

.logo {
  height: 50px;
}

.nav-links {
  display: flex;
  list-style: none;
}

.nav-links a {
  color: #fff;
  text-decoration: none;
  font-weight: 600;
  position: relative;
  transition: color 0.3s ease;
}

.nav-links a::after {
  content: '';
  position: absolute;
  width: 0;
  height: 2px;
  left: 0;
  bottom: -2px;
  background-color: #ff8f00;
  transition: width 0.3s ease;
}

.nav-links a:hover {
  color: #ff8f00;
}

.nav-links a:hover::after {
  width: 100%;
}

.navbar__right button {
  background: none;
  border: 1px solid #fff;
  color: #fff;
  padding: 6px 12px;
  margin-left: 10px;
  border-radius: 4px;
  cursor: pointer;
  font-weight: 600;
  transition: all 0.3s ease;
}

.navbar__right button:hover {
  background-color: #ff8f00;
  color: black;
  border-color: #ff8f00;
}
</style>

